/* ═══════════════════════════════════════════════════════════════
   SORISSE — email capture
   Exit intent on desktop, 55% scroll on mobile (no exit intent
   exists on touch). Never on cart or checkout, never twice.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var KEY = 'sorisse.cap';
  var box = document.getElementById('cap');
  if (!box) return;

  /* ── suppression rules ─────────────────────────────────────── */
  var path = location.pathname;
  if (/\/(cart|checkout|challenge|account)/.test(path)) return;   // never mid purchase

  var state = {};
  try { state = JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) {}
  if (state.subscribed) return;                                    // already on the list
  if (state.until && Date.now() < state.until) return;             // dismissed recently

  var remember = function (o) {
    try { localStorage.setItem(KEY, JSON.stringify(Object.assign(state, o))); } catch (e) {}
  };

  /* ── open / close ──────────────────────────────────────────── */
  var shown = false, lastFocus = null;

  function open() {
    if (shown) return;
    shown = true;
    lastFocus = document.activeElement;
    box.hidden = false;
    box.setAttribute('aria-hidden', 'false');
    var f = document.getElementById('capEmail');
    if (f && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      setTimeout(function () { f.focus(); }, 450);
    }
    document.addEventListener('keydown', onKey);
  }

  function close(days) {
    if (!shown) return;
    shown = false;
    box.hidden = true;
    box.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    remember({ until: Date.now() + (days || 30) * 864e5 });
  }

  function onKey(e) { if (e.key === 'Escape') close(30); }

  var x = document.getElementById('capX');
  var scrim = document.getElementById('capScrim');
  if (x) x.addEventListener('click', function () { close(30); });
  if (scrim) scrim.addEventListener('click', function () { close(30); });

  /* ── triggers ──────────────────────────────────────────────── */
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (fine) {
    // desktop: leaving through the top of the window
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 4) open();
    });
    // and a long dwell, for people who never leave the tab
    setTimeout(open, 75000);
  } else {
    // mobile: past the halfway mark means genuine interest
    var onScroll = function () {
      var h = document.documentElement;
      var pct = (h.scrollTop + window.innerHeight) / h.scrollHeight;
      if (pct > 0.55) { open(); window.removeEventListener('scroll', onScroll); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(open, 60000);
  }

  /* ── success state ─────────────────────────────────────────── */
  var form = document.getElementById('capForm');
  if (form) form.addEventListener('submit', function () {
    remember({ subscribed: true });
  });

  // Shopify bounces back with ?customer_posted=true
  if (/customer_posted=true/.test(location.search)) {
    remember({ subscribed: true });
    var inner = box.querySelector('.cap__box');
    if (inner) {
      inner.innerHTML =
        '<button class="cap__x" aria-label="Close">&times;</button>' +
        '<p class="cap__eyebrow">Thank you</p>' +
        '<h2 class="cap__title">It is on its way.</h2>' +
        '<p class="cap__done">Check your inbox, and your junk folder if it is not there in a few ' +
        'minutes. We will email you the day the test report arrives, whatever the number says.</p>';
      inner.querySelector('.cap__x').addEventListener('click', function () { close(3650); });
      open();
    }
  }
})();
